import styled from 'styled-components';
import colors from '_colors.module.scss';
import { BdsGrid } from 'blip-ds/dist/blip-ds-react';

export const ModalContent = styled(BdsGrid)`
  width: 536px;
`;

export const Subtitle = styled.div`
  bds-typo {
    color: ${colors.ContentDisable};
  }
`;

export const FileUploadContainer = styled.div<{ $isLoading?: boolean }>`
  margin: 8px 0;
  ${({ $isLoading }) =>
    $isLoading &&
    `
    pointer-events: none;
    opacity: 0.6;
    cursor: not-allowed;
  `}
`;
